import { ListItemLayout, ListItemSegment } from 'layouts/lists'
import { ListItemTitle, ListItemInfo } from 'components/lists/common'
import { ListItemCommonProps } from 'components/lists/types'
import { Root, IconChevron, IconWrapper } from './ActionListItem.styled'

const ActionListItem: React.FC<ListItemCommonProps> = props => {
  const { title, header, footer, onClick, dataTest } = props

  function handleClick() {
    onClick && onClick()
  }

  const Icon = () => (
    <IconWrapper>
      <IconChevron icon='chevron' data-test='ActionListItemChevron' />
    </IconWrapper>
  )

  return (
    <Root onClick={handleClick} clickable={!!onClick} data-test={dataTest || 'ActionListItem'}>
      <ListItemLayout>
        <ListItemSegment segmentId='header'>
          <ListItemInfo info={header} dataTest='ActionListItemHeader' />
        </ListItemSegment>
        <ListItemSegment segmentId='content'>
          <ListItemTitle title={title} dataTest='ActionListItemContent' />
        </ListItemSegment>
        <ListItemSegment segmentId='footer'>
          <ListItemInfo info={footer} dataTest='ActionListItemFooter' />
        </ListItemSegment>
        <ListItemSegment segmentId='sidebar'>
          <Icon data-test='ActionListItemIcon' />
        </ListItemSegment>
      </ListItemLayout>
    </Root>
  )
}

export default ActionListItem
